<div class="app-page-title">
    <div class="page-title-wrapper">
        <div class="page-title-heading">
            <div class="page-title-icon">
                <i class="pe-7s-culture icon-gradient bg-mean-fruit">
                </i>
            </div>
            <div>Comptes business
                <div class="page-title-subheading">La liste des comptes business.
                </div>
            </div>
        </div>
        <div class="page-title-actions">
            <div class="d-inline-block dropdown">
                <button type="button" class="btn btn-warning" [routerLink]="['/add-business-account']">
                    <span class="btn-icon-wrapper pr-2 opacity-7">
                        <i class="fa fa-business-time fa-w-20"></i>
                    </span>
                    Ajouter comptes business
                </button>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-md-12">
        <div class="main-card mb-3 card">
            <div class="card-header">Comptes business
                <!-- <div class="btn-actions-pane-right">
                    <div role="group" class="btn-group-sm btn-group">
                        <button class="active btn btn-focus">Last Week</button>
                        <button class="btn btn-focus">All Month</button>
                    </div>
                </div> -->
            </div>
            <div class="table-responsive">
                <div class="budget-price justify-content-center" *ngIf="allBusiness.length === 0">
                    <h5 class="text-center">Aucune comptes business créé</h5>
                </div>
                <table class="align-middle mb-0 table table-borderless table-striped table-hover"
                    *ngIf="allBusiness.length > 0">
                    <thead>
                        <tr>
                            <th class="text-center">#</th>
                            <th>Reférence</th>
                            <th>Société</th>
                            <th class="text-center">Téléphone</th>
                            <th class="text-center">Nombre<br>des<br>demandes</th>
                            <th class="text-center">Etat</th>
                            <!-- <th class="text-center">Pick UP</th> -->
                            <th class="text-center">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let business of allBusiness, let index = index">
                            <td class="text-center text-muted">#{{index+1}}</td>
                            <td>
                                {{business?.ref_account}}
                            </td>
                            <td>
                                <div class="widget-content p-0">
                                    <div class="widget-content-wrapper">
                                        <div class="widget-content-left mr-3">
                                            <div class="widget-content-left">
                                                <img width="40" height="40" class="rounded-circle"
                                                    src="{{'https://assets.marketbey.tn/Wassali/TRANSPORTOR/users-trans/' + business?.society?.profile_user}}"
                                                    alt="">
                                                <!-- <ngx-avatar class="rounded-circle" name="{{society.user_transportor.prenom_user}}
                                                {{society.user_transportor.nom_user}}">
                                                </ngx-avatar> -->
                                            </div>
                                        </div>
                                        <div class="widget-content-left flex2">
                                            <div class="widget-heading">{{business?.society?.prenom_user}}
                                                {{business?.society?.nom_user}}</div>
                                            <div class="widget-subheading opacity-7">
                                                {{business?.society?.email_user}}</div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="text-center"><strong>{{business?.society?.tel_user}}</strong>
                            </td>
                            <td class="text-center">
                                0
                            </td>
                            <td class="text-center">
                                <div class="badge badge-success">
                                    Validé
                                </div>
                            </td>
                            <td class="text-center">
                                <div class="mb-2 mr-2 dropright btn-group" ngbDropdown placement="left-top">
                                    <button class="btn-wide btn btn-info">Actions</button>
                                    <button type="button" ngbDropdownToggle
                                        class="dropdown-toggle-split dropdown-toggle btn btn-info"><span
                                            class="sr-only">Actions</span></button>
                                    <div ngbDropdownMenu>
                                        <button type="button" [routerLink]="['/detail-business-account']"
                                            [queryParams]="{ business: business.society._id }" tabindex="0" class="dropdown-item">
                                            <i class="metismenu-icon pe-7s-news-paper"
                                                style="margin-right: 10px;"></i>Details société
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>